import { Query } from '../Model/Query';
import { RecordLostObject } from '../Model/RecordLostObject';
export class RecordsLostObjectsService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findRegisters(opts) {
        var _a;
        if (((opts === null || opts === void 0 ? void 0 : opts.offset) || opts.offset >= 0) && (opts === null || opts === void 0 ? void 0 : opts.limit)) {
            const query = new Query(opts.offset, opts.limit);
            if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.search) {
                query.addFilter('search', [opts.filters.search]);
            }
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`register_lost_object?${params}`);
            if (!response.ok) {
                throw new Error(`Error al obtener los registros de objetos perdidos.`);
            }
            const content = await response.json();
            return content.map(lostObject => new RecordLostObject(lostObject).getState());
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async find() {
        const response = await this.apiService.get('register_lost_object');
        if (!response.ok) {
            throw new Error(`Error al obtener los objetos perdidos.`);
        }
        const content = await response.json();
        return content.map(lostObject => new RecordLostObject(lostObject).getState());
    }
    async saveRegisters(register) {
        const response = await this.apiService.post('register_lost_object', register instanceof RecordLostObject ? register.getState() : register);
        if (!response.ok) {
            throw new Error(`Error al obtener los registros de objetos perdidos.`);
        }
        return true;
    }
    async lastInRegister(year) {
        if (year) {
            const response = await this.apiService.get('register_lost_object_in_register/' + year);
            if (!response.ok) {
                throw new Error(`Error al obtener el numero de registro.`);
            }
            const content = await response.text();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener el año.`);
        }
    }
    async lastOutRegister(year) {
        if (year) {
            const response = await this.apiService.get('register_lost_object_out_register/' + year);
            if (!response.ok) {
                throw new Error(`Error al obtener el numero de registro.`);
            }
            const content = await response.text();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener el año.`);
        }
    }
    async getRecordsQuantity(opts) {
        var _a;
        const query = new Query();
        if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.search) {
            query.addFilter('search', [opts.filters.search]);
        }
        const params = this.queryParamsFactory.createQueryParams(query);
        const response = await this.apiService.get(`register_lost_object_quantity?${params}`);
        if (!response.ok) {
            throw new Error(`Error al obtener los objetos perdidos.`);
        }
        const content = await response.json();
        return parseInt(content);
    }
}
